<h2 class="text-xl font-semibold px-4 py-3">
    {{ data.showMyProfile ? 'Choisir un profil' : 'Choisir un profil joueur' }}
</h2>
<div class="p-4">
    <div class="space-y-4">
        <p class="text-gray-600">
            {{ data.showMyProfile
            ? 'Sélectionnez le profil que vous souhaitez consulter :'
            : 'Sélectionnez le profil joueur que vous souhaitez consulter :'
            }}
        </p>

        <div class="max-h-72 overflow-y-auto" *ngIf="!loading">
            <mat-radio-group [(ngModel)]="selectedOption">

                <div *ngIf="data.showMyProfile"
                     class="flex items-center gap-3 py-3 px-2 hover:bg-gray-50 rounded-lg transition-colors">
                    <mat-radio-button [value]="myProfileOption">
                        <div class="flex items-center gap-4 ml-2">
                            <div class="flex items-center justify-center w-10 h-10 bg-blue-100 rounded-full">
                                <span class="text-blue-600 font-medium">{{ getInitials(myProfileOption.first_name, myProfileOption.last_name) }}</span>
                            </div>
                            <div class="flex flex-col">
                                <span class="font-medium text-gray-900">{{myProfileOption.first_name}}   {{myProfileOption.last_name}}  </span>
                                <span class="text-sm text-gray-500">Voir votre propre profil</span>
                            </div>
                        </div>
                    </mat-radio-button>
                </div>

                <!-- Profils des enfants -->
                <div *ngFor="let child of children"
                     class="flex items-center gap-3 py-3 px-2 hover:bg-gray-50 rounded-lg transition-colors">
                    <mat-radio-button [value]="createChildOption(child)">
                        <div class="flex items-center gap-4 ml-2">
                            <div class="flex items-center justify-center w-10 h-10 bg-gray-200 rounded-full">
                                <span class="text-gray-600 font-medium">{{ getInitials(child.first_name, child.last_name) }}</span>
                            </div>
                            <div class="flex flex-col">
                                <span class="font-medium text-gray-900">{{ child.first_name }} {{ child.last_name }}</span>
                                <span class="text-sm text-gray-500">Profil joueur</span>
                            </div>
                        </div>
                    </mat-radio-button>
                </div>
            </mat-radio-group>
        </div>

        <!-- Messages d'état -->
        <div *ngIf="children.length === 0 && !loading && !data.showMyProfile" class="text-center py-8">
            <p class="text-gray-500">Aucun profil joueur trouvé</p>
        </div>

        <div *ngIf="children.length === 0 && !loading && data.showMyProfile" class="text-center py-4">
            <p class="text-gray-500">Aucun enfant trouvé</p>
        </div>

        <div *ngIf="loading" class="text-center py-8">
            <p class="text-gray-500">Chargement...</p>
        </div>
    </div>

    <!-- Boutons d'action -->
    <div class="flex flex-col sm:flex-row justify-end gap-2 mt-6 pt-4 border-t">
        <button mat-stroked-button (click)="onCancel()" class="px-6">
            Annuler
        </button>
        <button
            mat-flat-button
            color="primary"
            (click)="onConfirm()"
            [disabled]="!selectedOption"
            class="px-6"
        >
            <mat-icon class="mr-2">visibility</mat-icon>
            Voir le profil
        </button>
    </div>
</div>
